import type { SupportedLocales } from "#environment/i18nConfig"

export const ROUTE_LOCALIZATION_MAPPING: Record<string, Record<SupportedLocales, string>> = {
  // Static routes
  "/contact": {
    en: "/contact",
    de: "/kontakt",
  },

  // Legal
  "/data-privacy": {
    en: "/data-privacy",
    de: "/datenschutz",
  },
  "/imprint": {
    en: "/imprint",
    de: "/impressum",
  },
  "/terms-of-service": {
    en: "/terms-of-service",
    de: "/agb",
  },

  // Info
  "/buy-art": {
    en: "/buy-art",
    de: "/kunst-kaufen",
  },
  "/shipping-info": {
    en: "/shipping-info",
    de: "/versandinformationen",
  },

  // Purchasing routes
  "/checkout": {
    en: "/checkout",
    de: "/kasse",
  },
  "/checkout/order/[orderId]": {
    en: "/checkout/order/[orderId]",
    de: "/kasse/bestellung/[orderId]",
  },
  "/cart": {
    en: "/cart",
    de: "/warenkorb",
  },

  // Auth routes
  "/forgot-password": {
    en: "/forgot-password",
    de: "/passwort-vergessen",
  },
  "/login": {
    en: "/login",
    de: "/anmelden",
  },
  "/register": {
    en: "/register",
    de: "/registrieren",
  },
  "/register/confirmation/[email]": {
    en: "/register/confirmation/[email]",
    de: "/registrieren/confirmation/[email]",
  },
  "/reset-password": {
    en: "/reset-password",
    de: "/passwort-zurücksetzen",
  },

  // Dynamic routes
  "/artworks": {
    en: "/artworks",
    de: "/kunstwerke",
  },
  "/artworks/[slug]": {
    en: "/artworks/[slug]",
    de: "/kunstwerke/[slug]",
  },
  "/artists": {
    en: "/artists",
    de: "/künstler",
  },
  "/artists/[slug]": {
    en: "/artists/[slug]",
    de: "/künstler/[slug]",
  },

  // Account routes
  "/account/status": {
    en: "/account/status",
    de: "/konto/status",
  },
  "/account/profile": {
    en: "/account/profile",
    de: "/konto/profil",
  },
  "/account/verification": {
    en: "/account/verification",
    de: "/konto/verifizierung",
  },
  "/account/artworks": {
    en: "/account/artworks",
    de: "/konto/kunstwerke",
  },
  "/account/artworks/create": {
    en: "/account/artworks/create",
    de: "/konto/kunstwerke/erstellen",
  },
  "/account/artworks/create/info": {
    en: "/account/artworks/create/info",
    de: "/konto/kunstwerke/erstellen/info",
  },
  "/account/artworks/[slug]": {
    en: "/account/artworks/[slug]",
    de: "/konto/kunstwerke/[slug]",
  },
}
